import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/categoryList.css';
import Breadcrumb from '../Component/Layout/Breadcrumb';
import PatternFilter from '../Component/Layout/Filter/PatternFilter';
import SizeFilter from '../Component/Layout/Filter/SizeFilter';
import ColorFilter from '../Component/Layout/Filter/ColorFilter';
import AllFilter from '../Component/Layout/Filter/AllFilter';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import p1 from '../../src/assets/images/P-1.jpg'
import p2 from '../../src/assets/images/p-2.jpg'
import p3 from '../../src/assets/images/p-3.jpg'
import p4 from '../../src/assets/images/p-4.jpg'
import p5 from '../../src/assets/images/p-5.jpg'
import p6 from '../../src/assets/images/p-6.jpg'
import p7 from '../../src/assets/images/p-7.jpg'



const ProductList = () => {
  const [loading, setLoading] = useState(true);

  // Simulate data loading
  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Set loading state to false after 2 seconds
    }, 2000); 
  }, []);

  return (
    <>
      <Breadcrumb />
      <section className="category-List">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-7 col-sm-6 col-12">
              <div className="Filterbg">
                <PatternFilter />
                <SizeFilter />
                <ColorFilter />
                <AllFilter />
              </div>
            </div>
            <div className="col-lg-3 col-md-5 col-sm-6 col-12">
              <div className="input-icon">
                <i className="bi bi-search font-sm"> </i>
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control form-control-sm bg-white input"
                />
              </div>
            </div>
          </div>
        </div>
    </section>

    <section className="category-List">
        <div className="container">
            <div className="row">
          
          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p1} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

           <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p2} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

           <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p3} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p4} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p5} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

            <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p6} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p7} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>

           <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                  
                         <div className="latest-items latest-items2">
                                                      <div className="properties">
                                                        <div className="properties-card">
                                                          <div className="properties-img">
                                                            <Link to="/ProductDetails" target='_blank'> 
    <img src={p5} className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13" alt="Abby" />
                                                            </Link>
                                                            <span className="like-heart">
                                                              <a href="javascript:void(0);" onclick="addToWishlist(21262);">
                                                                <i id="fa-heart-21262" className="fa fa-heart-o" />
                                                              </a>
                                                            </span>
                                                          </div>
                                                          <div className="properties-caption properties-caption2">
                                                            <h3 style={{ fontSize: "17px !important"}}>
                                                              <Link to="/" className="text-gray-600 text-decoration-none" >
                                                              Beige Color Carpet
                                                              </Link>
                                                            </h3>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
           </div>





        </div>
        

      </div>
      </section>
    </>
  );
};

export default ProductList;
